module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo03-8a2dd4c586a91b12d161ca9f73ddc0ef.jpg";